<template>
  <div>
    <div class="py-2 text-general">
      <div class="p-2 d-flex justify-content-between">
        <label class="header-text text-main">แลกของรางวัล</label>
      </div>
      <div class="p-2 detail-panel mb-3">
        <div class="d-flex">
          <b-input-group>
            <b-form-input
              id="redeem-search"
              class="input-serach m-0"
              placeholder="ชื่อลูกค้า / หมายเลขเบอร์โทรศัพท์ลูกค้า"
              @keypress="handlePushMessage"
              v-model="filter.search"
            ></b-form-input>
          </b-input-group>
          <b-button class="search-circle-bth" @click="search"
            ><span class="icon-input m-auto pr-2">
              <font-awesome-icon icon="search" title="View" /> </span
          ></b-button>
        </div>
      </div>
      <div class="p-2 header-text">
        <b-row no-gutters class="mb-3">
          <b-col cols="5" class="font-weight-bold">หมายเลขสมาชิก</b-col>
          <b-col cols="7" class="text-right text-gray-2">{{
            form.member_id || "-"
          }}</b-col>
        </b-row>
        <b-row no-gutters class="mb-3">
          <b-col cols="5" class="font-weight-bold">ชื่อลูกค้า</b-col>
          <b-col cols="7" class="text-right text-gray-2"
            >{{ form.first_name_th || "-" }}{{ form.last_name_th }}</b-col
          >
        </b-row>
        <b-row no-gutters class="mb-3">
          <b-col cols="5" class="font-weight-bold">เบอร์โทรศัพท์</b-col>
          <b-col cols="7" class="text-right text-gray-2">{{
            form.telephone || "-"
          }}</b-col>
        </b-row>
        <b-row no-gutters class="mb-3">
          <b-col cols="5" class="font-weight-bold">คะแนนสะสม</b-col>
          <b-col cols="7" class="text-right text-gray-2">{{
            form.point | numeral("0,0")
          }}</b-col>
        </b-row>
        <b-row no-gutters class="mb-3">
          <b-col cols="5" class="font-weight-bold">คะแนนสะสมกลาง</b-col>
          <b-col cols="7" class="text-right text-gray-2">{{
            form.center_point | numeral("0,0")
          }}</b-col>
        </b-row>
      </div>
      <div class="p-2 mt-5">
        <div class="mt-2 text-center">
          <b-button
            :disabled="!form.member_id"
            class="radius-btn w-75 mb-2"
            @click="handleRedeemProduct"
          >
            <span> แลกของรางวัล </span>
          </b-button>
          <router-link :to="`/redeem/history/${form.member_id}`">
            <b-button class="radius-btn w-75" variant="outline"
              >ดูรายการแลกของรางวัล</b-button
            >
          </router-link>
        </div>
      </div>
    </div>
    <ModalProduct :data="productList" :customer="form" ref="modalProduct" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import { required } from "vuelidate/lib/validators";
import ModalProduct from "./components/ModalProduct.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    InputText,
    ModalLoading,
    ModalProduct,
  },
  validations() {
    return {
      form: {
        sales_no: { required },
      },
    };
  },
  computed: {
    ...mapGetters({ salesNo: "getSalesNo" }),
    ...mapGetters({ branchId: "getBranchId" }),
  },
  data() {
    return {
      error: "",
      isLoading: false,
      filter: {
        search: "",
      },
      productList: [],
      form: {
        user_id: 0,
        user_guid: "",
        first_name_th: "",
        last_name_th: "",
        point: 0,
        branch_point: 0,
        center_point: 0,
        telephone: "",
        member_id: "",
        birthday: "",
        birthday_string: null,
        home_address: "",
        is_validate_address: 0,
        is_validate_telephone: 0,
        gender: "",
        zip_code: null,
        province: "",
        town: "",
        alley: "",
        road: "",
        subdistrict: "",
        district: "",
        email: "",
        first_name_en: "",
        last_name_en: "",
        nickname: "",
        member_level_name: "",
        is_birthday: 0,
        line_id: "",
        the_one_card_member: 0,
        line_ref: "",
        credit: 0.0,
        consent_status: "",
      },
    };
  },
  async created() {},
  methods: {
    handlePushMessage(e) {
      let value = e.target.value;
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.search();
      }
    },
    search() {
      let body = {
        search: this.filter.search,
        branch_id: this.branchId,
        start: 0,
        length: 8,
      };

      this.axios
        .post(`${this.$baseUrl}/redeem/search_user_redeem_by_name`, body)
        .then((data) => {
          if (data.result == 1) {
            let res = data.detail;
            if (data.total_count > 0) {
              this.GetUserByID(data.detail[0].user_guid);
            } else this.warningAlert("ไม่พบข้อมูลสมาชิก");
          } else {
            this.warningAlert(data.message);
          }
        });
    },
    GetUserByID: async function (userGuid) {
      await this.axios
        .get(
          `${this.$baseUrl}/customer/user_lookup_byid/${userGuid}/${this.branchId}`
        )
        .then((data) => {
          if (data.result == 1) {
            this.form = data.detail;
          } else {
            this.warningAlert(data.message);
          }
        });
    },
    handleRedeemProduct: async function () {
      let body = {
        user_guid: this.form.user_guid,
        branch_id: this.branchId,
      };
      await this.axios
        .post(`${this.$baseUrl}/redeem/get_redeem_item_list`, body)
        .then((data) => {
          if (data.result == 1) {
            this.productList = data.detail;
          } else {
            this.warningAlert(data.message);
          }
        });

      this.$refs.modalProduct.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-outline {
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
  color: var(--primary-color) !important;
}
</style>
